import { endOfDay, startOfDay, subDays } from 'date-fns';

import { FilterOptions } from './model/filter-options.model';
import { OrderBy } from './model/order-by.model';
import { Status } from './model/status.model';
import { ViewCategory } from './model/view-category.model';
import { ViewItem } from './model/view-item.model';

export interface EventCentreDialogState {
    categories?: ViewCategory[];
    navCategories?: ViewCategory[];
    categoryId?: string;
    category?: ViewCategory;
    searchOpen?: boolean;
    filterOpts: FilterOptions;
    filterIsDefault?: { search?: boolean; filter?: boolean };
    orderBy: OrderBy;
    items?: ViewItem[];
    filteredItems?: ViewItem[];
    seenItems?: number[];
}

export const defaultState = (): EventCentreDialogState => ({
    filterOpts: {
        statuses: [Status.READ, Status.UNREAD],
        dateRange: {
            from: startOfDay(subDays(new Date(), 10)),
            to: endOfDay(new Date()),
        },
    },
    orderBy: OrderBy.DATE_DESC,
});
